// import * as L from 'leaflet';
import { Component, Output, EventEmitter, inject } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { fromLonLat , toLonLat} from 'ol/proj';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Icon from 'ol/style/Icon';
import Modify from 'ol/interaction/Modify';
import * as turf from '@turf/turf';
import XYZ from 'ol/source/XYZ';
import { Collection } from 'ol';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Style, Fill, Stroke, Circle as CircleStyle } from 'ol/style'; // ✅ Fix: Rename to CircleStyle
import { defaults as defaultInteractions } from 'ol/interaction';
import { NgbDropdownModule, NgbOffcanvasModule } from '@ng-bootstrap/ng-bootstrap';
import { DelayOnSearchService } from '@core/services/delayOnSearch.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  standalone:true,
  imports:[FormsModule, CommonModule , NgbDropdownModule, NgbOffcanvasModule]
})
export class MapComponent {
  map!: Map;
  userMarker!: Feature;
  pathLine!: Feature;
  vectorSource!: VectorSource;
  debounceService = inject(DelayOnSearchService)
  
  // Kaaba Coordinates (Longitude, Latitude)
  kaabaCoords = [39.826206, 21.4225];
  @Output() lat_emit = new EventEmitter<string>();
  @Output() long_emit = new EventEmitter<string>();
  bearing: any = 0;
  searchMarker!: Feature;
  searchQuery = '';
  searchResults: any[] = [];
  isLandingPage: boolean = false
  subscription!: Subscription;
  loader: boolean = false;
  
  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.initializeMap();
    console.log( window.location.href);
    if(window.location.href.includes("landing")){
      this.isLandingPage = true
    }else{
      this.isLandingPage = false
    }
    this.subscription = this.debounceService.onDebounce(1200).subscribe(value => {
      this.searchfilter(value);
    });
  }

  onSearchChange(value: string) {
    this.debounceService.emitValue(value);
  }

  searchfilter(value: string) {
    console.log('Searching for:', value);
    this.searchLocation();
  }

  searchLocation() {
    if (this.searchQuery.length < 3) {
      this.searchResults = [];
      this.loader = false;
      return;
    }
    this.loader = true;

    // const url = `https://nominatim.openstreetmap.org/search?format=json&countrycodes=my&q=${this.searchQuery}`;
    // const url = `https://geocode.xyz/${this.searchQuery}?json=1&region=MY`;

    // const url = `https://photon.komoot.io/api/?q=${this.searchQuery}&limit=5`;
    const url = `https://photon.komoot.io/api/?q=${this.searchQuery}&limit=5`;
    this.http.get(url).subscribe((data: any) => {
      this.searchResults = data.features;
      this.loader = false;

    });
  }


selectLocation(location: any) {
  // Extract selected coordinates
  const newLonLat = [
    location.geometry.coordinates[0], // Longitude first
    location.geometry.coordinates[1]  // Latitude second
  ];
  const newCoords = fromLonLat(newLonLat); // Convert to OpenLayers coords

  // Update the search query
  this.searchQuery = location.properties.name || location.properties.street || '';
  this.searchResults = [];

  // Update User Marker
  this.userMarker.setGeometry(new Point(newCoords));

  // Move Map View to Selected Location
  this.map.getView().setCenter(newCoords);
  this.map.getView().setZoom(17);

  // Emit New Coordinates
  this.long_emit.emit(newLonLat[0].toString());
  this.lat_emit.emit(newLonLat[1].toString());

  // Recalculate the path to Kaaba (Great-Circle Curve)
  const kaabaPoint = fromLonLat(this.kaabaCoords);
  const curvedLine = this.createGreatCircleCurve(newCoords, kaabaPoint);
  this.pathLine.setGeometry(curvedLine);

  // Calculate new bearing to Kaaba
  const kaabaBearing = this.calculateBearing(newLonLat, this.kaabaCoords);
  console.log('Updated Bearing to Kaaba:', kaabaBearing);

  // If there's a user-placed pin, update its path
  const pinFeature = this.vectorSource.getFeatures().find(f => f.get('name') === 'User Pin');
  if (pinFeature) {
    const pinCoords = toLonLat((pinFeature.getGeometry() as Point).getCoordinates());

    // Update bearing to the pin
    const pinBearing = this.calculateBearing(newLonLat, pinCoords);
    this.bearing = pinBearing;
    console.log('Updated Bearing to Pin:', pinBearing);

    // Ensure Great-Circle Path is used
    const curvedPinLine = this.createGreatCircleCurve(newCoords, fromLonLat(pinCoords));
    const pinPath = new Feature(curvedPinLine);
    pinPath.setStyle(
      new Style({
        stroke: new Stroke({
          color: 'red',
          width: 3
        })
      })
    );
    pinPath.set('name', 'User Path');

    // Remove old path and add the updated one
    this.vectorSource.getFeatures().forEach((feature) => {
      if (feature.get('name') === 'User Path') {
        this.vectorSource.removeFeature(feature);
      }
    });
    this.vectorSource.addFeature(pinPath);
  }
}
switchBaseLayer(layerTitle: string): void {
  this.map.getLayers().forEach((layer: any) => {
    if (layer.get('title')) {
      layer.setVisible(layer.get('title') === layerTitle);
    }
  });
}

initializeMap(): void {
  navigator.geolocation.getCurrentPosition((position) => {
    const userCoords = [position.coords.longitude, position.coords.latitude];
    this.long_emit.emit(position.coords.longitude.toString());
    this.lat_emit.emit(position.coords.latitude.toString());

    const userPoint = fromLonLat(userCoords);
    const kaabaPoint = fromLonLat(this.kaabaCoords);

    // Initialize Vector Source
    this.vectorSource = new VectorSource();
    const vectorLayer = new VectorLayer({ source: this.vectorSource });


    const streetLayer = new TileLayer({
      source: new OSM(),
      visible: false
    });
    streetLayer.set('title', 'Street');
    
    const satelliteLayer = new TileLayer({
      source: new XYZ({
        url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}' // Satellite
      }),
      visible: true
    });
    satelliteLayer.set('title', 'Satellite');
    
    const hybridLayer = new TileLayer({
      source: new XYZ({
        url: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}' // Hybrid (labels + satellite)
      }),
      visible: false
    });
    hybridLayer.set('title', 'Hybrid');
    
    // Initialize the map
    this.map = new Map({
      target: 'map',
      layers: [
        streetLayer,
        satelliteLayer,
        hybridLayer,
        vectorLayer
      ],
      view: new View({
        center: userPoint,
        zoom: 17
      }),
      controls: [],
      interactions: defaultInteractions({
        pinchRotate: false,          
        altShiftDragRotate: false  
      })
    });

    // Create user marker (Draggable)
    this.userMarker = new Feature({
      geometry: new Point(userPoint),
      name: 'User Location'
    });
    this.userMarker.setStyle(
      new Style({
        image: new Icon({
          src: 'assets/images/current_marker.png',
          scale: 0.18,
          anchor: [0.5, 0.9],
        })
      })
    );

    // Create Kaaba marker (Not draggable)
    const kaabaMarker = new Feature({
      geometry: new Point(kaabaPoint),
      name: 'Kaaba'
    });
    kaabaMarker.setStyle(
      new Style({
        image: new Icon({
          src: 'assets/images/kaaba.png',
          scale: 0.10
        })
      })
    );

    // Create line from user to Kaaba (Not draggable)
    const curvedLine = this.createGreatCircleCurve(userPoint, kaabaPoint);
    this.pathLine = new Feature(curvedLine);
    this.pathLine.setStyle(
      new Style({
        stroke: new Stroke({
          color: 'red',
          width: 3
        })
      })
    );

    // Add user marker, Kaaba marker, and path line
    this.vectorSource.addFeatures([this.userMarker, kaabaMarker, this.pathLine]);

    // Create a collection of features that can be modified (only the user marker)
    const draggableFeatures = new Collection([this.userMarker]);

    // Enable dragging of the user marker ONLY
    const modify = new Modify({
      source: this.vectorSource,
      features: draggableFeatures, // Only the user marker is draggable
      hitDetection: vectorLayer,
      style: new Style({
        image: new CircleStyle({ // ✅ Corrected from CircleStyle to Circle
          radius: 0, // Hide the anchor
          fill: new Fill({ color: 'rgba(0, 0, 0, 0)' }), // Make it transparent
          stroke: new Stroke({ color: 'rgba(0, 0, 0, 0)', width: 0 }) // Remove outline
        })
      })

    });
    this.map.addInteraction(modify);
    
    modify.on('modifyend', () => {
      const newUserPoint = this.userMarker.getGeometry() as Point;
      const newUserCoords = newUserPoint.getCoordinates();
      const newUserLonLat = toLonLat(newUserCoords);
    
      this.long_emit.emit(newUserLonLat[0].toString());
      this.lat_emit.emit(newUserLonLat[1].toString());
    
      // Recalculate the curved path to Kaaba
      const kaabaPoint = fromLonLat(this.kaabaCoords);
      const curvedLine = this.createGreatCircleCurve(newUserCoords, kaabaPoint);
      this.pathLine.setGeometry(curvedLine);
    
      // Calculate bearing to Kaaba
      const kaabaBearing = this.calculateBearing(newUserLonLat, this.kaabaCoords);
      console.log('Updated Bearing to Kaaba:', kaabaBearing);
    
      // Check if the pin exists and update its path
      const pinFeature = this.vectorSource.getFeatures().find((f) => f.get('name') === 'User Pin');
      if (pinFeature) {
        const pinPoint = pinFeature.getGeometry() as Point;
        const pinCoords = pinPoint.getCoordinates();
        const pinLonLat = toLonLat(pinCoords);
    
        // Update bearing to the pin
        const pinBearing = this.calculateBearing(newUserLonLat, pinLonLat);
        this.bearing = pinBearing; // Update UI if needed
        console.log('Updated Bearing to Pin:', pinBearing);
    
        // Update the **curved** path from user to pin
        const curvedPinLine = this.createGreatCircleCurve(newUserCoords, fromLonLat(pinLonLat));
        const pinPath = new Feature(curvedPinLine);
        pinPath.setStyle(
          new Style({
            stroke: new Stroke({
              color: 'yellow',
              width: 3
            })
          })
        );
        pinPath.set('name', 'User Path');
    
        // Remove old path and add the updated one
        this.vectorSource.getFeatures().forEach((feature) => {
          if (feature.get('name') === 'User Path') {
            this.vectorSource.removeFeature(feature);
          }
        });
        this.vectorSource.addFeature(pinPath);
      }
    });
    

    // Enable user to place a pin
    this.map.on('click', (event) => {
      const clickedCoord = toLonLat(event.coordinate);

      // Remove only the old pin and path to pin (not Kaaba or user marker)
      this.vectorSource.getFeatures().forEach((feature) => {
        if (feature.get('name') === 'User Pin' || feature.get('name') === 'User Path') {
          this.vectorSource.removeFeature(feature);
        }
      });

      // Create new pin feature
      const pinFeature = new Feature({
        geometry: new Point(event.coordinate),
        name: 'User Pin'
      });

      pinFeature.setStyle(
        new Style({
          image: new Icon({
            src: 'assets/images/secondary_marker.png',
            scale: 0.18,
            anchor: [0.5, 0.9]
          })
        })
      );

      // Add the pin to the map
      this.vectorSource.addFeature(pinFeature);
// Add the pinFeature to the draggable features collection
      draggableFeatures.push(pinFeature);
      // Create line from user to pin
      const newUserPoint: any = this.userMarker.getGeometry();
      const curvedPinLine = this.createGreatCircleCurve(newUserPoint?.getCoordinates() || userPoint, event.coordinate);
      const pinPath = new Feature(curvedPinLine);
      pinPath.setStyle(
        new Style({
          stroke: new Stroke({
            color: 'yellow',
            width: 3
          })
        })
      );
      pinPath.set('name', 'User Path');

      // Add path to the map
      this.vectorSource.addFeature(pinPath);

      // // Calculate bearing to Kaaba
      // const kaabaBearing = this.calculateBearing(userCoords, this.kaabaCoords);
      // console.log('Bearing to Kaaba:', kaabaBearing);

      // // Calculate bearing to User Pin
      // const pinBearing = this.calculateBearing(userCoords, clickedCoord);
      // this.bearing = pinBearing;
      // console.log('Bearing to Pin:', pinBearing);
      // Get latest user marker coordinates
const currentUserPoint = this.userMarker.getGeometry() as Point;
const currentUserCoords = toLonLat(currentUserPoint.getCoordinates());

// Calculate bearing to Kaaba
const kaabaBearing = this.calculateBearing(currentUserCoords, this.kaabaCoords);
console.log('Bearing to Kaaba:', kaabaBearing);

// Calculate bearing to User Pin
const pinBearing = this.calculateBearing(currentUserCoords, clickedCoord);
this.bearing = pinBearing;
console.log('Bearing to Pin:', pinBearing);

    });
  });
}
  

  
  calculateBearing(startCoords: number[], endCoords: number[]): string {
    const toRadians = (degrees: number) => degrees * (Math.PI / 180);

    const lat1 = toRadians(startCoords[1]);
    const lon1 = toRadians(startCoords[0]);
    const lat2 = toRadians(endCoords[1]);
    const lon2 = toRadians(endCoords[0]);

    const deltaLon = lon2 - lon1;

    const y = Math.sin(deltaLon) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLon);

    let bearing = Math.atan2(y, x) * (180 / Math.PI);
    bearing = (bearing + 360) % 360; // Normalize 0-360°

    // ✅ Convert to DMS format
    const degrees = Math.floor(bearing);
    const minutesFloat = (bearing - degrees) * 60;
    const minutes = Math.floor(minutesFloat);
    const seconds = Math.round((minutesFloat - minutes) * 60);

    return `${degrees}° ${minutes}' ${seconds}"`;
    
  }


  
  createGreatCircleCurve(start: number[], end: number[]): LineString {
    const startPoint = turf.point(turf.toWgs84(start)); // Convert from EPSG:3857 to WGS84
    const endPoint = turf.point(turf.toWgs84(end));
  
    // Create a great-circle line with intermediate points
    const options = { npoints: 100 }; // Increase for a smoother curve
    const curvedLine = turf.greatCircle(startPoint, endPoint, options);
  
    // Convert back to OpenLayers projection
    const coordinates:any = curvedLine.geometry.coordinates.map(coord => turf.toMercator(coord));
  
    return new LineString(coordinates);
  }
  clearBearingLine(): void {
    const featuresToRemove = this.vectorSource.getFeatures().filter(
      (feature) =>
        feature.get('name') === 'User Path' || feature.get('name') === 'User Pin'
    );
  
    featuresToRemove.forEach((feature) => {
      this.vectorSource.removeFeature(feature);
    });
  
    // Optionally reset the bearing value
    this.bearing = 0;
  }
  
}
